<body style="background-color: #2C3B51;">
	<div class="sticky">
		<header class="header">
			<div class="shell shell--size-1">
				<div class="header__inner">
					<a href="#home" class="logo">
						<img src="assets/img/Cosmic Algorithm Brand Assets-10.png" alt="Cosmic Algorithm Logo"
							loading="lazy">
					</a>

					<div class="header__aside">
						<nav class="nav hidden-xs">
							<ul style="list-style-type: none;">
								<li>
									<a href="https://cosmic-algorithm.ie/" target="_blank">IBKR</a>
								</li>
		
								<li>
									<a [routerLink]="['/home/fxcm']">FXCM</a>
								</li>
		
								<li>
									<!-- <a onClick="document.location='/#etoroLoc';">eToro</a> -->
									<a href="https://backseat-trader.com/" target="_blank">eToro</a>
								</li>
		
							</ul>
						</nav><!-- /.nav -->

						<div class="header__actions">
<!-- 
							<button class="btn btn--secondary hidden-xs"><a style="all: unset;" [routerLink]="['/platform/profiles']" (click)="capturePos()">My Profile</a></button>
	
							<a [routerLink]="['/platform/live']" class="btn btn--size-1" (click)="capturePos()">Live</a>
		
							<a [routerLink]="['/platform/profiles']" class="btn btn--secondary btn--xs hidden visible-xs-inline-block">
								<img src="assets/img/svg/ico-profile.svg" alt="Click here for your profile"
									loading="lazy" (click)="capturePos()">
							</a>	 -->


						</div><!-- /.header__actions -->

					</div><!-- /.header__aside -->
				</div><!-- /.header__inner -->
			</div><!-- /.shell -->
		</header><!-- /.header -->
	</div>
	<script src="assets/vendor/jquery-3.6.0.min.js"></script>
	<script src="assets/js/bundle.js"></script>
	<div>

		<div class="hero" id="home">
			<div class="shell shell--size-2">
				<nav class="nav hidden visible-xs-block">
					<ul>
						<li>
							<a href="https://cosmic-algorithm.ie/" target="_blank">IBKR</a>
						</li>

						<li>
							<a [routerLink]="['/home/fxcm']">FXCM</a>
						</li>

						<li>
							<!-- <a onClick="document.location='/#etoroLoc';">eToro</a> -->
							<a href="https://backseat-trader.com/" target="_blank">eToro</a>
						</li>

					</ul>
				</nav><!-- /.nav -->
				<div class="hero__media">
					<button data-bs-toggle="modal" data-bs-target="#myModal" style="    
					background: none;
					border: none;
					padding: 0;
					width: 100%;
					height: 100%;" *ngIf="mobile">
						
						<div class="hero__image heroImg"></div><!-- /.hero__image -->

						<p class="hero__play js-play" target="_blank">
							<img src="assets/img/svg/ico-play.svg" alt="Play button">
						</p>
						<!-- /.hero__media -->
					</button>
					<button data-bs-toggle="modal" data-bs-target="#myModal" *ngIf="!mobile">
						
						<div class="hero__image heroImg"></div><!-- /.hero__image -->

						<p class="hero__play js-play" target="_blank">
							<img src="assets/img/svg/ico-play.svg" alt="Play button">
						</p>
						<!-- /.hero__media -->
					</button>
				</div>

				<div class="hero__content" *ngIf="!mobile">
					<h1 id="title" class="simplifiedDesk">Our algorithms backtest to a range of returns from <span style="color:green">15 - 45%</span>, depending on the risk return profile selected</h1>

					<ul>
						<li class="wow fadeInUp" data-wow-delay=".5s">
							<img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy">

							<img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
								class="hidden visible-xs-block">

								They expeditiously mitigate downside losses
						</li>

						<li class="wow fadeInUp" data-wow-delay="1.5s">
							<img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy" />

							<img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
								class="hidden visible-xs-block">

								Chase gains to the upside
						</li>

						<li class="wow fadeInUp" data-wow-delay="2.5s">
							<img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy">

							<img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
								class="hidden visible-xs-block">

								Trades long or short simultaneously
						</li>
						<li class="wow fadeInUp" data-wow-delay="3.5s">
							<img src="assets/img/svg/ico-check.svg" alt="Check mark" class="hidden-xs" loading="lazy">

							<img src="assets/img/svg/ico-check-mobile.svg" alt="Check mark" loading="lazy"
								class="hidden visible-xs-block">

								AI integral to development
							</li>
						</ul>
						We measure relative performance against recognised benchmarks
					<!-- <div style="width:100%; text-align: center;">					
						<a [routerLink]="['/join-us']" class="btn joinUsBtn" rel="noopener noreferrer"
							id="homeJoinUs1" (click)="capturePos()">Join us on eToro</a><br/><br/>
							<div style="font-size:smaller">
								Copy Trading does not amount to investment advice. Your investments value may go up or down. Your capital is at risk.
							</div>
					</div> -->
				</div><!-- /.hero__content -->
				<div class="hero__content" *ngIf="mobile">
					
					<h1 id="title" class="simplifiedMob">Our algorithms backtest to a range of returns from <span style="color:green">15 - 45%</span>, depending on the risk return profile selected</h1>

					<ul>
						<li class="wow fadeInUp" data-wow-delay=".5s">
							<img src="assets/img/svg/ico-check.svg" alt="" class="hidden-xs">

							<img src="assets/img/svg/ico-check-mobile.svg" alt="" class="hidden visible-xs-block">

							They expeditiously mitigate downside losses
						</li>

						<li class="wow fadeInUp" data-wow-delay="1.5s">
							<img src="assets/img/svg/ico-check.svg" alt="" class="hidden-xs">

							<img src="assets/img/svg/ico-check-mobile.svg" alt="" class="hidden visible-xs-block">

							Chase gains to the upside
						</li>

						<li class="wow fadeInUp" data-wow-delay="2.5s">
							<img src="assets/img/svg/ico-check.svg" alt="" class="hidden-xs">

							<img src="assets/img/svg/ico-check-mobile.svg" alt="" class="hidden visible-xs-block">

							Trades long or short simultaneously
						</li>
						<li class="wow fadeInUp" data-wow-delay="3.5s">
							<img src="assets/img/svg/ico-check.svg" alt="" class="hidden-xs">

							<img src="assets/img/svg/ico-check-mobile.svg" alt="" class="hidden visible-xs-block">

							AI integral to development
						</li>
					</ul>
					<div style="color: black">We measure relative performance against recognised benchmarks</div>
				</div><!-- /.hero__content -->
			</div><!-- /.shell -->
		</div><!-- /.hero -->
	</div>
</body>

<div class="modal" id="myModal">
	<div class="modal-dialog modal-fullscreen">
		<div class="modal-content">


			<div class="modal-body">
				<video height="95%" width="100%" controls #homeVideo>
					<source src="https://theapi.backseat-trader.com/Introducing-eToro.mp4" type="video/mp4">
				</video>
			</div>

			<!-- Modal footer -->
			<div class="modal-footer" style="    margin: auto;
			margin-bottom: 1%;
			margin-top: -1%;">
				<button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="close(homeVideo)">Close</button>
			</div>

		</div>
	</div>
</div>